var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17C653",
    fillRule: "evenodd",
    d: "M3.87.583h4.293l3.635 3.793v7.37c0 .922-.748 1.67-1.67 1.67H3.87a1.67 1.67 0 0 1-1.672-1.67V2.254c0-.923.749-1.672 1.672-1.672",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.16.583v3.76h3.641z",
    clipRule: "evenodd",
    opacity: 0.302
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.027 9.998h1.704v.646H5.027zm2.236-3.3h1.71v.641h-1.71zm-2.236 0h1.704v.641H5.027zm2.236 1.086h1.71v.646h-1.71zm-2.236 0h1.704v.646H5.027zm2.236 1.129h1.71v.646h-1.71zm-2.236 0h1.704v.646H5.027zm2.236 1.085h1.71v.646h-1.71z",
    clipRule: "evenodd"
  })));
};
export default SvgExcel;